export class SetupPermission {
    public Setup: number;
    public Group: string;
}
